import React, { useState, useCallback } from 'react';
import Tippy from 'utils/Tippy';

import { useItineraryDetail } from 'modules/dispatching/service';

import StopCard from 'modules/gatekeeping/stop';

const LoadingFallback = () => {
  return (
    <>
      <StopCard hasComments />
      <StopCard hasComments />
    </>
  );
};

const StopsTooltipContent = ({ itinerary }) => {
  const hasComments = itinerary?.stops?.some((stop) => !!stop?.comments?.length);

  return (
    <>
      {itinerary?.stops?.map((stop, key) => (
        <StopCard key={key} stop={stop} hasComments={hasComments} showAggregatedLoads={true} />
      ))}
    </>
  );
};

const StopsTooltip = ({ className, id, children }) => {
  const [mounted, setMounted] = useState(false);
  const { itinerary } = useItineraryDetail(mounted ? id : null);

  const getContent = useCallback(() => {
    return !itinerary ? <LoadingFallback /> : <StopsTooltipContent itinerary={itinerary} />;
  }, [itinerary]);

  const handleShow = useCallback(() => {
    setMounted(true);
  }, []);

  const handleHidden = useCallback(() => {
    setMounted(false);
  }, []);

  return (
    <>
      <Tippy
        placement="bottom"
        interactive={true}
        offset={[0, 0]}
        trigger="click"
        interactiveBorder={5}
        interactiveDebounce={50}
        appendTo={document.body}
        content={getContent()}
        maxWidth={'none'}
        theme="light"
        className={className}
        onShow={handleShow}
        onHidden={handleHidden}
      >
        {children}
      </Tippy>
    </>
  );
};

export default StopsTooltip;
